import React, { useState } from 'react';
import { Button } from '@mui/material';

const SelectorDual = ({ id, options, onSelect, initialValue }) => {
	const [selectedOption, setSelectedOption] = useState(
		initialValue || options[0]?.value
	);

	const handleSelect = (option) => {
		setSelectedOption(option.value);
		onSelect({ id, value: option.value });
	};

	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'space-between',
				gap: '8px',
				padding: '4px',
				backgroundColor: '#fafcfe',
				border: '1px solid #e3e5e9',
				borderRadius: '8px',
			}}>
			{options.map((option) => (
				<Button
					key={option.value}
					onClick={() => handleSelect(option)}
					variant='contained'
					disableElevation
					sx={{
						flex: 1,
						textTransform: 'none',
						fontWeight: 700,
						fontSize: '12px',
						padding: '8px 18px',
						fontFamily: 'Satoshi, sans-serif',
						borderRadius: '8px',
						color: selectedOption === option.value ? '#ffffff' : '#0b0f31',
						backgroundColor:
							selectedOption === option.value ? '#1c32f3' : 'transparent',
						boxShadow: selectedOption === option.value ? '#00000033' : 'none',
						transition: 'color 0.2s ease, background-color 0.2s ease',
						'&:hover': {
							color: selectedOption === option.value ? '#ffffff' : '#1c32f3',
							backgroundColor:
								selectedOption === option.value ? '#1c32f3' : 'transparent',
						},
					}}>
					{option.label}
				</Button>
			))}
		</div>
	);
};

export default SelectorDual;
